import { Paper, Grid } from "@material-ui/core";
import { InputTextMaster, LabelRequired } from "App/Component/ui";

export default function LokasiKontak({ formDataKontak, setFormDataKontak }) {
	const handleChange = (text) => (e) => {
		setFormDataKontak({
			...formDataKontak,
			[text]: e.target.value,
		});
	};

	return (
		<>
			<Paper className="p-1 mb-1">
				<h4>INFO KONTAK</h4>

				<form onSubmit={(e) => console.log("No Method")}>
					<Grid container spacing={1}>
						<Grid item md={4}>
							<InputTextMaster
								name="phone"
								label="No. Telepon"
								id="phone"
								placeholder="No. Telepon"
								value={formDataKontak.phone}
								onChange={handleChange("phone")}
							/>
						</Grid>
						<Grid item md={4}>
							<InputTextMaster
								name="email"
								label="Email"
								id="email"
								placeholder="Email"
								value={formDataKontak.email}
								onChange={handleChange("email")}
							/>
						</Grid>
						<Grid item md={4}>
							<InputTextMaster
								name="url"
								label="Url"
								id="url"
								placeholder="Url"
								value={formDataKontak.url}
								onChange={handleChange("url")}
							/>
						</Grid>
					</Grid>
				</form>
			</Paper>
		</>
	);
}
